module.exports = __webpack_public_path__ + "static/media/type.f56bf684.svg";